import { tw } from "tw-lite";

export const BaseIndicator = tw("span")`rounded px-3 py-2`;
